import AnalyticFields from '../../enums/AnalyticFields';

export default function getMeasures(accountId) {
  if (!accountId) return [];
  const { Revenue, Impressions, Clicks, Request } = AnalyticFields;

  return [
    `${accountId}.${Revenue.name}`,
    `${accountId}.${Impressions.name}`,
    `${accountId}.${Clicks.name}`,
    `${accountId}.${Request.name}`,
  ];
}
